var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeLazerBeneficio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.969,
    height: 100.424,
    viewBox: "0 0 226.969 100.424",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 0.182)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 60.323)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.591 19.319)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.075 65.842)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.484 75.305)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.418 44.092)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 7.992,
    transform: "rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.171 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 7.993,
    transform: "translate(7.993 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.554 29.898)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 7.992,
    transform: "rotate(-90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.171 0) rotate(135)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 7.993,
    transform: "translate(7.993 0) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.405 55.591)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.495 14.588)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 18.925,
    transform: "translate(18.925) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.319)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.348,
    cy: 17.348,
    r: 17.348,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.348,
    cy: 17.348,
    r: 14.348,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.826 0.322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.605,356.383a2.688,2.688,0,0,0,3.7-.8l.055-.117.034-.02c12.35-10.964,29.592-5.132,29.763-5.07l.11.027a2.606,2.606,0,0,0,3.389-.762c.055-.075,6.092-8.014,19.842-4.419a2.507,2.507,0,0,0,.776.076,2.644,2.644,0,0,0,1.75-.034,2.686,2.686,0,0,0,1.578-3.451c-6.559-17.585-26.984-27.513-48.576-23.595l-.116.027h-.014c-.274.055-.549.11-.817.165a2.844,2.844,0,0,0-.6.123c-20.782,4.412-35.67,20.535-35.622,38.854a2.689,2.689,0,0,0,2.683,2.676h.007a2.651,2.651,0,0,0,1.976-.892C564.919,351.148,573.214,356.136,573.605,356.383Zm3.5-7.485c-.651-16.247,6.463-22.874,9.359-24.892,3.431.871,12.432,4.583,17.53,20.061C597.8,342.928,586.834,342.311,577.1,348.9Zm50.237-9.749c-8.789-1.112-14.662,1.839-17.914,4.315-3.4-11.005-8.679-17.194-13.42-20.659C609.351,323.072,621.393,329.275,627.341,339.148Zm-50.449-12.569c-3.094,4.871-5.695,12.322-5.1,23.362-3.9-1.009-9.921-1.372-17.063,2.243C556.8,341.337,565.255,331.676,576.892,326.578Z",
    transform: "translate(-548.851 -307.845)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.335,322.821l5.283-.954-.672-3.684a2.682,2.682,0,1,0-5.276.961Z",
    transform: "translate(-520.873 -315.977)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.265,329.09H555.8l1.338,7.177a2.679,2.679,0,0,0,2.635,2.2,3,3,0,0,0,.494-.041,2.689,2.689,0,0,0,2.148-3.135Z",
    transform: "translate(-508.099 -239.125)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.634,323.629l5.413,29.1H565.5l-5.592-30.072A23.746,23.746,0,0,0,554.634,323.629Z",
    transform: "translate(-514.957 -276.841)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.227,326.82a2.685,2.685,0,1,0-4.83-2.346L630.7,342.415H600.063a2.683,2.683,0,0,0,0,5.365h6.868l-4.487,7.5H553.477a2.683,2.683,0,1,0,0,5.365h10.147l-5.839,9.743a2.683,2.683,0,0,0,.926,3.684,2.646,2.646,0,0,0,1.372.384,2.685,2.685,0,0,0,2.305-1.3l7.492-12.508H622.91l7.492,12.508a2.685,2.685,0,0,0,4.6-2.765L628.4,359.369a2.086,2.086,0,0,0,.165-.233Zm-31.039,20.96H628.1l-3.5,7.232a2.82,2.82,0,0,1-.433.268H608.7Z",
    transform: "translate(-537.463 -275.037)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLazerBeneficio);
export default __webpack_public_path__ + "static/media/icone-lazer-beneficio.db9e822f302c06a036d70a65fae335e7.svg";
export { ForwardRef as ReactComponent };